// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Tdyx","content":"styles_content__35f8q"};